import { Component, OnInit, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog, MatSort, PageEvent } from '@angular/material';
import { AddVehicleComponent } from './add-vehicle/add-vehicle.component';
import { HttpService } from '../http.service';

import { Subscription, Subject } from 'rxjs';
import { EventService } from '../event.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { AttachDriverComponent } from '../attach-driver/attach-driver.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { Messages } from '../constants/messages';
import { EditVehicleComponent } from './edit-vehicle/edit-vehicle.component';
import { ViewVehicleComponent } from './view-vehicle/view-vehicle.component';
import { debounceTime, distinctUntilChanged, map, filter } from 'rxjs/operators';
import { BulkUploadComponent } from '../bulk-upload/bulk-upload.component';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import { TimeService } from '../time.service';
import { BulkUploadVehicleComponent } from '../bulk-upload-vehicle/bulk-upload-vehicle.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface Vehicles {
  _id: string;
  vehicle: {
    type: string,
    id: string,
  },
  tank: {
    mileage: number,
    mileage_unit: string,
    capacity: number,
    capacity_unit: string,
  },
  registration: {
    year: number,
    chassis_number: string,
    engine_number: number,
  },
  gps?: {
    id: string,
    proider: string
  },
  vehicleNumber: string;
  bodyType: string;
  currentLocation: string;
}

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss']
})
export class VehiclesComponent implements OnInit {

  vehicleDownloadDample = environment.VEHICLE_BULK_UPLOAD_SAMPLE;
  showLoader = false;
  markMaintainanceRef: any;
  dedicateVehicleToRef: any;
  VideoLinkRef: any;
  totalvehicles = 0;
  vehicleArray: any = [];
  vehicleCount = 0;
  vehicleList: MatTableDataSource<Vehicles>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('uploadDialog', { static: true }) uploadDialog: TemplateRef<any>;
  @ViewChild('markMaintainance', { static: true }) markMaintainance: TemplateRef<any>;
  @ViewChild('dedicateVehicleTo', { static: true }) dedicateVehicleTo: TemplateRef<any>;
  @ViewChild("openVideos", { static: true }) openVideos: TemplateRef<any>;
  vehicleFilters: any = {};
  allVehicles: any = [];
  filters: any = {
    vehicleType: [],
    vehicleNumber: '',
    dedicated_to: '',
  };

  trackingTypes = [{
    name: 'SIM Based Tracking',
    checked: 'false'
  }, {
    name: 'APP Based Tracking',
    checked: 'false'
  }, {
    name: 'GPS Based Tracking',
    checked: 'false'
  }];
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];

  carrierUpdates: Subscription;
  errors = new Messages();

  subscription: Subscription;
  searchTextChanged = new Subject<object>();
  uploadDocsRef: any;
  fileLength = 0;
  vehicleId = '';
  regFormData = new FormData();

  mark_type: any;
  min_due_date;
  video_URL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.ADDING_VEHICLE);
  columnsToDisplay = ['slno', 'vehicleType', 'dedicatedTo', 'status', 'driver_details', 'action'];//fuel-consumption,vehicle_condition,last_maintenance
  due_date: any
  due_date_string;
  selected_vehicle_data;
  showYesNo;
  entityArray = [];
  selectedShipper: any;
  fuel_card_feature = false;

  in_maintainance = false;
  in_use = false;
  shippersArr = [];
  shipper = '';
  vehicleNumber = '';
  isShowAddDedicatedVechicle = false;
  tracking = [];
  non_tracking = [];
  trackingCount:any=0;
  nonTrackingCount:any=0;
  nonTracking: [string, unknown][];

  constructor(private dialog: MatDialog, private events: EventService, private storage: StorageService, private route: Router,
    private http: HttpService, private changeDetection: ChangeDetectorRef, private translation: TranslateService,
    private snackbar: SnackbarService, private valid: ValidationService, private timeserive: TimeService, private sanitizer: DomSanitizer) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnInit() {
    this.paginator._intl.itemsPerPageLabel = "Vehicles per page";
    this.getVehicles();
    this.getVehicleTypes();
    this.getShippers();
    this.carrierUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getVehicles();
      }
    );
  }

  ngOnDestroy() {
    this.carrierUpdates.unsubscribe();
  }

  reSubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.searchTextChanged.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      map(search => search)
    ).subscribe((x) => {
      this.removeFocus();
      this.getVehicles(x);
    });
    this.changeDetection.detectChanges();
  }

  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }

  selectTrackType(track, event) {
    // TODO:
  }

  openAddVehicle() {
    const dialogRef = this.dialog.open(AddVehicleComponent, {
      // data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.statusCode == 200) {
        this.getVehicles(this.vehicleFilters);
      }
    });
  }
  getVehicles(filter: any = {}) {

    this.showLoader = true;
    if (!filter.limit && !filter.skip) {
      filter.limit = this.paginator.pageSize || 25;
      filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    }

    this.http.post('vehicle/many', filter, 3).subscribe(
      (data: any) => {
        this.showLoader = false;
        const vehicles = data.data.vehicles;
        const vehicleArr = [];
        this.vehicleCount = data.data.count;
        if(data.data.gpsStatus){
          let trackingData = Object.entries(data.data.gpsStatus.tracking);
          let nonTrackingData = Object.entries(data.data.gpsStatus.nonTracking);
  
          this.tracking = trackingData.filter(x => x[0] != 'count');
          this.nonTracking = nonTrackingData.filter(x => x[0] != 'count');
  
          let trackingCount = trackingData.filter(x => x[0] == 'count');
          this.trackingCount = (trackingCount.length > 0) ? trackingCount[0][1] : 0;
          let nonTrackingCount = nonTrackingData.filter(x => x[0] == 'count');
          this.nonTrackingCount = (nonTrackingCount.length > 0) ? nonTrackingCount[0][1] : 0;
        }
        vehicles.forEach((element, index) => {
          const temp: any = {
            vehicle: {},
            tank: {},
            registration: {},
            gps: {}
          }

          temp._id = element._id;
          temp.index = index + 1;
          temp.capacity = element.capacity;
          temp.vehicle.name = element.type.name ? element.type.name : "N/A";
          temp.vehicle._id = element.type._id;
          temp.vehicle.capacity = element.type.capacity ? element.type.capacity : 0;
          temp.tank.mileage = element.tank ? element.tank.mileage : 0;
          temp.tank.mileage_unit = element.tank ? element.tank.mileage_unit : '';
          temp.tank.capacity = element.tank ? element.tank.capacity : 0;
          temp.tank.capacity_unit = element.tank ? element.tank.capacity_unit : '';
          temp.registration.year = element.registration ? element.registration.year : 0;
          temp.registration.chassis_number = element.registration ? element.registration.chassis_number : '';
          temp.registration.engine_number = element.registration ? element.registration.engine_number : 0;
          temp.vehicleNumber = element.REG_number;
          temp.maintenance = element.maintenance ? element.maintenance.in_service : false;
          temp.maintenance_due_date = element.maintenance ? element.maintenance.due_date : '';
          temp.dedicated_to = element.dedicated_to ? element.dedicated_to.parent_name + ' - ' + element.dedicated_to.name : 'N/A';
          temp.gps.id = element.gps ? element.gps.id : '';
          temp.in_shipment = element.in_shipment;
          if (temp.in_shipment) {
            temp.trip_status = "On Shipment"
          } else {
            temp.trip_status = "Free"
          }
          temp.gps.provider = element.gps ? element.gps.provider : '';
          temp.bodyType = element.type.body_type;
          temp.vehicle_pic = element.vehicle_pic ? element.vehicle_pic.original : '';
          temp.attached = (element.attached_driver && element.attached_driver.length) ? true : false;
          // temp.cardPAN = (element.iocl && element.iocl.card_number) ? element.iocl.card_number : ''; // card pan variable here
          temp.cardPAN = (element.attached_io_card && element.attached_io_card.card_number) ? element.attached_io_card.card_number : ''; // new card pan variable
          temp.transporter = element.transporter ? element.transporter : undefined;
          temp.attached_drivers_array = element.attached_driver || [];
          temp.attached_drivers_name = '';
          element.attached_driver.forEach((item, i) => {
            // console.log('item',i,item)
            if(item.shipment && item.shipment.trip_tracker && item.shipment.trip_tracker.last_location_address){
              temp.last_location_address = item.shipment.trip_tracker.last_location_address;
            }
            if (i == 0) {
              return;
            } else if (i == element.attached_driver.length - 1) {
              temp.attached_drivers_name += item.name;
            } else temp.attached_drivers_name += item.name + '';
          });
          temp.attached_driver_data = element.attached_driver ? element.attached_driver[0] : '';
          if (temp.attached_driver_data) {
            temp.driverName = temp.attached_driver_data.name;
            temp.driverMobile = temp.attached_driver_data.mobile;
            temp.last_online_time = temp.attached_driver_data.last_online_time;
            let last = this.diff_minutes(new Date(), new Date(temp.last_online_time));
            if (last <= 20) {
              temp.status = 'Online'
            }

            if (temp.attached_driver_data.geo_point) {
              temp.current_location = {
                longitude: temp.attached_driver_data.geo_point.coordinates[0],
                latitude: temp.attached_driver_data.geo_point.coordinates[1]
              }
            }
          } else {
            temp.driverName = '';
            temp.driverMobile = '';
          }
          console.log(temp.last_location_address);
          vehicleArr.push(temp);
        });

        if (!this.vehicleList) {
          this.vehicleList = new MatTableDataSource(vehicleArr);
          this.vehicleList.sort = this.sort;
          this.vehicleList.paginator = this.paginator;
        } else {
          this.vehicleList = new MatTableDataSource(vehicleArr);
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  diff_minutes(dt2, dt1) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  pageNavigate(event: PageEvent) {
    this.vehicleFilters.limit = event.pageSize;
    this.vehicleFilters.skip = event.pageIndex * event.pageSize;
    this.getVehicles(this.vehicleFilters);
  }

  getVehicleTypes() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {

          if (data.data.vehicle_types.length) {
            this.allVehicles = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  selectVehicleType(vehicle, event) {
    if (event.source._selected) {
      if (this.filters.vehicleType.indexOf(vehicle._id) == -1) {
        this.filters.vehicleType.push(vehicle._id);
      }
    } else if (!event.source._selected) {
      if (this.filters.vehicleType.indexOf(vehicle._id) > -1) {
        this.filters.vehicleType.splice(this.filters.vehicleType.indexOf(vehicle._id), 1);
      }
    }
  }

  searchFilter(value, type) {

    this.changeDetection.detectChanges();
    if (type != 'type' && value.length) {
      switch (type) {
        case 'number':
          this.vehicleFilters.number = value;
          break;
        case 'dedicated_to':
          this.vehicleFilters.dedicated_to = value;
          break;
      }
      this.reSubscribe();
      this.searchTextChanged.next(this.vehicleFilters);
    } else if (type == 'type' && value.length) {
      this.vehicleFilters.types = value;
      this.reSubscribe();
      this.searchTextChanged.next(this.vehicleFilters);
    } else {
      this.clearFilter(type);
    }

  }

  clearFilter(type) {
    switch (type) {
      case 'type':
        delete this.vehicleFilters.types;
        break;
      case 'number':
        delete this.vehicleFilters.number;
        break;
    }
    this.getVehicles(this.vehicleFilters);
  }

  clearAll() {
    this.vehicleFilters = {};
    this.filters = {
      vehicleType: [],
      vehicleNumber: '',
    };
    this.getVehicles(this.vehicleFilters);
  }

  openBulkUpload() {
    const dialogData: any = {
      sampleURL: this.vehicleDownloadDample,
      heading: this.translation.instant('BULKUPLOAD.uploadFile'),
      fileHeading: this.translation.instant('BULKUPLOAD.uploadFile'),
      uploadURL: 'vehicle/bulk_upload',
    };
    const dialogRef = this.dialog.open(BulkUploadVehicleComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getVehicles(this.vehicleFilters);
      }
    });
  }

  openEditVehicleComponent(element) {
    const dialogRef = this.dialog.open(EditVehicleComponent, {
      data: element
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getVehicles(this.vehicleFilters);
      }
    });
  }

  //view vehicle details 
  openViewVehicle(vehicle) {
    const dialogRef = this.dialog.open(ViewVehicleComponent, {
      data: vehicle
    });
  }
  openAttachDriverComponent(data, type) {
    if (type == 'Attach') {
      const dialogRef = this.dialog.open(AttachDriverComponent, {
        data: data._id
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.statusCode == 200 || result == 'yes') {
          this.getVehicles(this.vehicleFilters);
        }
      });
    } else if (type == 'Detach') {
      const dialogData = {
        name: 'Detach Driver',
        text: this.errors.VEHICLES.DIALOGDATA.DETACHDRIVER,
        driver_id: data.attached_driver_data._id,
        url: 'driver/detach'
      }
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.statusCode == 200 || result == 'yes') {
          this.getVehicles(this.vehicleFilters);
        }
      });
    }
  }
  fileChanged(event: any) {
    if (event.target.files.length && (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png')) {
      this.fileLength = event.target.files.length;
      for (let x = 0; x < this.fileLength; x++) {
        this.regFormData.append('vehiclePic', event.target.files[x]);
      }
    } else {
      this.snackbar.openSnackBar(this.translation.instant('VEHICLE.image'), '', 'err');
      this.regFormData.delete('vehiclePic');
    }
  }
  openUploadDialog(element) {
    this.regFormData = new FormData();
    this.vehicleId = element._id;
    this.uploadDocsRef = this.dialog.open(this.uploadDialog);
    this.uploadDocsRef.afterClosed().subscribe(data => {
      if (data && data.statusCode == 200) {
        this.getVehicles(this.vehicleFilters);
      }
    })
  }
  uploadRegDocs(element) {
    if (this.fileLength > 0) {
      this.showLoader = true;
      this.http.upload('v2/vehicle/upload/' + this.vehicleId, this.regFormData).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar(this.translation.instant('VEHICLE.docsUpload'), '');
            this.vehicleId = '';
            this.fileLength = 0;
            this.uploadDocsRef.close(data);
            this.regFormData = new FormData();
          }
        },
        (err: any) => {
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
          this.regFormData = new FormData();
        }
      );
    } else {
      this.snackbar.openSnackBar(this.translation.instant('VEHICLE.image'), '', 'err');
    }
  }

  openMarkMaintainanceDialog(element, type) {
    this.selected_vehicle_data = element;
    this.mark_type = type;
    this.min_due_date = new Date();
    this.showYesNo = this.mark_type == 'markIn' ? true : false;
    this.vehicleId = element._id;
    this.markMaintainanceRef = this.dialog.open(this.markMaintainance);
    this.markMaintainanceRef.afterClosed().subscribe((data) => {
      if (data && data.statusCode == 200) {
        this.getVehicles(this.vehicleFilters);
      }
    })
  }

  openDedicateVehicleToDialog(element, type) {

    if (type == 'Add') {
      this.isShowAddDedicatedVechicle = true;
    } else {
      this.isShowAddDedicatedVechicle = false;
    }

    this.vehicleId = element._id;
    this.vehicleNumber = element.vehicleNumber;
    this.dedicateVehicleToRef = this.dialog.open(this.dedicateVehicleTo);
    this.dedicateVehicleToRef.afterClosed().subscribe((data) => {
      this.shipper = '';
    })


  }

  getEpoch(value) {
    this.due_date = this.timeserive.toUTCEpoch(value);
  }

  closeModal(data: any) {
    this.due_date = '';
    this.due_date_string = '';
    this.markMaintainanceRef.close(data)
  }

  markMaintainanceSubmit() {
    let url;
    const payload: any = {
      vehicle_id: this.selected_vehicle_data._id
    };
    if (this.selected_vehicle_data.maintenance) {
      url = "/v1/vehicle/out_of_maintainance";
      if (this.due_date) {
        payload.maintainance_due_date = this.due_date;
      }
    } else {
      url = "/v1/vehicle/in_maintainance";
    }
    this.showLoader = true;
    this.http.post(url, payload, 3).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.showLoader = false;
        if (this.selected_vehicle_data.maintenance) {
          this.snackbar.openSnackBar(this.translation.instant('VEHICLE.maintenanceOut_success'));
        } else {
          this.snackbar.openSnackBar(this.translation.instant('VEHICLE.maintenanceIn_success'));
        }
        this.closeModal(response);
      }
    },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      })
  }

  openAddVehicleVideoLink() {

    this.VideoLinkRef = this.dialog.open(this.openVideos, {

    });
  }

  getShippers() {
    this.showLoader = true;
    this.http.get('shippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.shippersArr = [];
          const result = data.data;
          result.forEach((element, i) => {
            const temp: any = {};
            temp._id = element._id;
            temp.name = element.parent_name + ' - ' + element.name;
            this.shippersArr.push(temp);
          });
        }
      },
      (err: any) => {
        console.log(err.error.message);
      }
    );
  }

  dedicatedVehicleTo() {

    let payload = {}
    let url = '';

    if (this.isShowAddDedicatedVechicle) {
      url = 'v1/vehicle/dedicate/' + this.vehicleId;
      payload = {
        dedicated_to: this.shipper
      }
    }
    else {
      url = 'v1/vehicle/removededicate/' + this.vehicleId;
    }

    this.showLoader = true;
    this.http.put(url, payload, 3).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.showLoader = false;
          if (this.isShowAddDedicatedVechicle)
            this.snackbar.openSnackBar(this.translation.instant('VEHICLE.dedicated_vehicle_success'));
          else
            this.snackbar.openSnackBar(this.translation.instant('VEHICLE.dedicated_vehicle_remove'));

          this.dedicateVehicleToRef.close();
          this.getVehicles();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        this.dedicateVehicleToRef.close();
      })

  }
  openVehicleMapView() {
    this.route.navigateByUrl('own-vehicle-map-view');
  }
  getColor(name) {
    (2)
    switch (name) {
      case 'running':
        return '#089981';
      case 'idle':
        return '#FF9800';
      case 'halt':
        return '#D60023';
      case 'noData':
        return '#131722';
      case 'offline':
        return '#2962FF';
      case 'dead':
        return '#851951';
    }
  }
}
